import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IPolicyAsset } from 'src/app/modules/shared/models/policy.model';
import { DIVESTMENT_ASSETS_TABLE_TABLE_KEYS } from './branch-switch-divestment.constants';

@Component({
  selector: 'app-branch-switch-divestment',
  templateUrl: './branch-switch-divestment.component.html',
  styleUrl: './branch-switch-divestment.component.scss',
})
export class BranchSwitchDivestmentComponent implements OnDestroy {

  @Input() form: FormGroup;
  @Input() policyFunds: IPolicyAsset[] = [];
  @Input() isReadOnly: boolean;
  @Output() emitFunds = new EventEmitter<any>();
  tableKeys: ITableKey[] = DIVESTMENT_ASSETS_TABLE_TABLE_KEYS;
  destroy$ = new Subject();

  isIncorrectValue(value): boolean {
    if (value) {
      if (value.includes('.')) {
        return true;
      }
      else {
        return isNaN(parseFloat(value.replace(',', '.')));
      }
    }
  }

  maxAmountLimit(fund): boolean {
    let fundAmount = fund?.fundAmount?.split('.').join('');
    fundAmount = fundAmount?.replace(',', '.');
    return parseFloat(fund.amount) > parseFloat(fundAmount);
  }

  readFunds(funds: IPolicyAsset[]) {
    this.emitFunds.emit(funds);
  }

  get showFunds(): boolean {
    return this.policyFunds && this.policyFunds.length > 0;
  }

  get totalDisinvestmentAmount(): number {
    const value = this.policyFunds.reduce((acc, fund) => {
      let amount = fund?.amount;
      amount = amount.replace(/\./g, '');
      amount = amount.replace(',', '.'); 
      return acc + parseFloat(amount);
    }, 0);
    return value;
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
